module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-11.ddea4088.png";